<template>
  <PageHeader :title="$t('ui.entities.dashboards.callCenter')">
    <template #right>
      <Select
        v-model="callCenterSelected"
        :options="callCentersAllowed"
        value-key="id"
        label-key="name"
        :placeholder="`Select a Call Center`"
        class="max-w-52"
        :readonly="callCentersAllowed.length == 1"
        @select="updateCallCenterSelected"
      ></Select>
    </template>
  </PageHeader>

  <div v-if="callCenterSelected">
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
      <Card class="col-span-1">
        <CardBody>
          <CardTitle title="Team Members" />
        </CardBody>
      </Card>
      <Card class="col-span-1">
        <CardBody>
          <CardTitle title="KPI" />
        </CardBody>
      </Card>
      <Card class="col-span-1 sm:col-span-2">
        <CardBody>
          <CardTitle title="Stats" />
        </CardBody>
      </Card>
    </div>

    <div class="grid grid-cols-1">
      <Card>
        <CardBody>
          <CardTitle title="Activity Summary" />
        </CardBody>
      </Card>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <Card class="col-span-1 md:col-span-2">
        <CardBody>
          <CardTitle title="Today's Shifts" />
        </CardBody>
      </Card>
      <Card>
        <CardBody>
          <CardTitle title="Team Leaderboard" />
        </CardBody>
      </Card>
    </div>
  </div>

  <Empty
    v-else-if="!callCentersAllowed.length"
    title="No call centers"
    description="You haven't been added to any call centers"
    icon="headset"
  />
  <Empty
    v-else
    title="No call center selected"
    description="Select a call center"
    icon="headset"
  />
</template>

<script setup>
import { ref } from 'vue'
import PageHeader from '@/components/page/PageHeader.vue'
import Card from '@/components/card/Card.vue'
import CardBody from '@/components/card/CardBody.vue'
import CardTitle from '@/components/card/CardTitle.vue'
import Select from '@/components/forms/Select.vue'

import { useUserStore } from '@/stores/UserStore.ts'
import Empty from '@/components/empty/Empty.vue'

const userStore = useUserStore()

const callCentersAllowed = userStore.callCenters
const callCenterSelected = ref(null)

if (!localStorage.getItem('report-filter-call-center-selected')) {
  localStorage.setItem('report-filter-call-center-selected', callCentersAllowed[0]?.id)
  callCenterSelected.value = callCentersAllowed[0]?.id
} else {
  callCenterSelected.value = parseInt(localStorage.getItem('report-filter-call-center-selected'))
}

function updateCallCenterSelected() {
  localStorage.setItem('report-filter-call-center-selected', callCenterSelected.value)
}
</script>

<style></style>
